// ============================================================
// [2.13.0] Carte d'identité publique du serveur (GET /server-info), lue une
// fois par page : mode tout-en-un, émetteurs SSO (« Se connecter avec mon
// compte Siverix »), instance réclamée (clé de privilège), serveur de comptes
// (page « Serveurs Siverix »). Un échec vaut « inconnu » (null) et sera retenté
// au prochain appel.
// ============================================================

import { useEffect, useState } from 'react';
import type { ServerInfo } from '@siverix/shared';
import { api } from '../api';

let pending: Promise<ServerInfo | null> | null = null;

export function loadServerInfo(): Promise<ServerInfo | null> {
  if (!pending) {
    pending = api.getServerInfo().catch(() => {
      pending = null;
      return null;
    });
  }
  return pending;
}

/** Oublie la carte en mémoire (après une clé de privilège : `claimed` change). */
export function forgetServerInfo(): void {
  pending = null;
}

export function useServerInfo(): { info: ServerInfo | null; loading: boolean } {
  const [info, setInfo] = useState<ServerInfo | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    void loadServerInfo().then((i) => {
      if (!alive) return;
      setInfo(i);
      setLoading(false);
    });
    return () => {
      alive = false;
    };
  }, []);
  return { info, loading };
}
